import { useState, createContext, useRef, useContext } from 'react'
import { Popover as ReactTinyPopover } from 'react-tiny-popover'

import useClickOutside from 'hooks/useClickOutside'

import ToolbarContext from '../../toolbarContext'

import styles from './Popover.module.scss'

export const PopoverContext = createContext({})

const Popover = ({ trigger, children }) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false)
    const contentRef = useRef()

    const { toolbarRef } = useContext(ToolbarContext)

    useClickOutside(contentRef, () => setIsPopoverOpen(false))

    return (
        <ReactTinyPopover
            parentElement={toolbarRef?.current || undefined}
            boundaryElement={document.body}
            containerClassName={styles.popover}
            isOpen={isPopoverOpen}
            positions={['bottom', 'top', 'left', 'right']}
            padding={2}
            content={
                <PopoverContext.Provider value={{ onClosePopover: () => setIsPopoverOpen(false) }}>
                    <div ref={contentRef} className={styles.popoverContent}>
                        {children}
                    </div>
                </PopoverContext.Provider>
            }
        >
            <div className={styles.parent} onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
                {trigger}
            </div>
        </ReactTinyPopover>
    )
}

export default Popover
